if (!customElements.get("add-to-wishlist-button")) {
  class AddToWishlistButton extends HTMLElement {
    productTitle = "";
    productHandle = "";
    productOptions = {};
    productPrice = 0;
    infiniteAppProductOptions = {};
    infiniteAppProductPrice = 0;
    allProductOptions = {};
    fullProductPrice = 0;
    productRentalPricePercentage = null;
    fullProductRentalPrice = null;
    enableRentalOverAmount = null;
    image = null;
    vendor = null;
    variantId = null;

    constructor() {
      super();
    }

    connectedCallback() {
      this.init();

      // Add click event listener
      this.addEventListener("click", this.handleClick.bind(this));

      document.addEventListener(
        "on:variant:change",
        this.onVariantChange.bind(this)
      );
    }

    disconnectedCallback() {
      // Remove click event listener
      this.removeEventListener("click", this.handleClick.bind(this));

      document.removeEventListener(
        "on:variant:change",
        this.onVariantChange.bind(this)
      );
    }

    init() {
      console.log("AddToWishlistButton init");

      try {
        const data = JSON.parse(
          document.getElementById(`wishlist-product-${this.dataset.productId}`)
            .textContent
        );
        this.productTitle = data.title;
        this.productHandle = data.handle;
        this.productOptions = data.options;
        this.allProductOptions = this.productOptions;
        this.productPrice = data.price;
        this.fullProductPrice = this.productPrice;
        this.productRentalPricePercentage = data.rentalPricePercentage;
        this.enableRentalOverAmount = data.enableRentalOverAmount;
        this.fullProductRentalPrice = this.getFullRentalPrice();
        this.image = data.image;
        this.vendor = data.vendor;
        this.variantId = data.variant_id;
      } catch (e) {
        console.error("Error parsing wishlist product options", e);
      }

      "Shoppad.apps.infiniteoptions".split(".").reduce(function (o, x) {
        if (!o[x]) {
          o[x] = {};
        }
        return o[x];
      }, window);

      const originalBeforeReady =
        window.Shoppad.apps.infiniteoptions.beforeReady;
      window.Shoppad.apps.infiniteoptions.beforeReady = (subscribe) => {
        if (originalBeforeReady) {
          originalBeforeReady.call(this, subscribe);
        }

        subscribe("fieldLoad", this.onFieldLoad.bind(this));
        subscribe("fieldChange", this.onFieldChange.bind(this));
        subscribe("productBundleAdd", this.onProductBundleAdd.bind(this));
        subscribe("productBundleRemove", this.onProductBundleRemove.bind(this));
      };
    }

    getFullRentalPrice() {
      return this.productRentalPricePercentage !== null &&
        this.enableRentalOverAmount !== null &&
        this.fullProductPrice >= this.enableRentalOverAmount
        ? (this.fullProductPrice * this.productRentalPricePercentage) / 100
        : null;
    }

    onVariantChange(event) {
      console.log("onVariantChange", event);

      const optionsName = event.detail.product.options;
      const optionsValue = event.detail.variant.options;

      optionsName.forEach((name, index) => {
        this.productOptions[name] = optionsValue[index];
      });

      this.productPrice = event.detail.variant.price;
      this.variantId = event.detail.variant.id;
      this.updateOptionsAndPrice();
    }

    updateOptions() {
      this.allProductOptions = {
        ...this.productOptions,
        ...this.infiniteAppProductOptions,
      };
    }

    updatePrice() {
      this.fullProductPrice = this.productPrice + this.infiniteAppProductPrice;
      this.fullProductRentalPrice = this.getFullRentalPrice();
    }

    updateOptionsAndPrice() {
      this.updateOptions();
      this.updatePrice();
    }

    onFieldLoad(event) {
      this.infiniteAppProductOptions[event.detail.name] = event.detail.value;
      const fieldPrice =
        parseFloat(
          event.detail.fieldConfig.values.find(
            (value) => value.label === event.detail.value
          )?.variant?.price || 0
        ) * 100;
      this.infiniteAppProductPrice += fieldPrice;
      this.updateOptionsAndPrice();
    }

    onFieldChange(event) {
      this.infiniteAppProductOptions[event.detail.name] = event.detail.value;
      this.updateOptionsAndPrice();
    }

    onProductBundleAdd(event) {
      window.Shoppad.apps.infiniteoptions.getLatestVariantPrice(
        event.detail.productBundle,
        (productBundle) => {
          const fieldPrice = parseFloat(productBundle?.price || 0) * 100;
          this.infiniteAppProductPrice += fieldPrice;
          this.updateOptionsAndPrice();
        }
      );
    }

    onProductBundleRemove(event) {
      window.Shoppad.apps.infiniteoptions.getLatestVariantPrice(
        event.detail.productBundle,
        (productBundle) => {
          const fieldPrice = parseFloat(productBundle?.price || 0) * 100;
          this.infiniteAppProductPrice -= fieldPrice;
          this.updateOptionsAndPrice();
        }
      );
    }

    handleClick() {
      if (this.getAttribute("aria-disabled") === "true") return;

      this.setAttribute("aria-disabled", "true");
      this.classList.add("is-loading");

      let wishlist = [];

      try {
        wishlist = JSON.parse(localStorage.getItem("wishlist") || "[]");
      } catch (e) {
        console.error("Error parsing wishlist", e);
      }

      const productId = this.dataset.productId;

      // Get quantity from the form
      const form = this.closest("form");
      const quantityInput = form
        ? form.querySelector('[name="quantity"]')
        : null;
      const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

      const productData = {
        id: productId,
        options: this.allProductOptions,
        price: this.fullProductPrice,
        rentalPrice: this.fullProductRentalPrice,
        quantity: quantity,
        image: this.image,
        title: this.productTitle,
        vendor: this.vendor,
        handle: this.productHandle,
        addedAt: new Date().toISOString(),
        variantId: this.variantId,
      };

      // Check if identical product exists in wishlist
      const existingIndex = wishlist.findIndex(
        (item) =>
          item.id === productId &&
          item.price === this.fullProductPrice &&
          item.rentalPrice === this.fullProductRentalPrice &&
          JSON.stringify(item.options) ===
            JSON.stringify(this.allProductOptions)
      );

      if (existingIndex >= 0) {
        // Update existing product
        wishlist[existingIndex].quantity += productData.quantity;
      } else {
        // Add as new product
        wishlist.push(productData);
      }

      // Simulate loading
      setTimeout(() => {
        this.setAttribute("aria-disabled", "false");
        this.classList.add("is-success");

        localStorage.setItem("wishlist", JSON.stringify(wishlist));

        // Dispatch storage event for other components
        window.dispatchEvent(
          new StorageEvent("storage", {
            key: "wishlist",
            newValue: JSON.stringify(wishlist),
          })
        );
        setTimeout(() => {
          this.classList.remove("is-loading");
          this.classList.remove("is-success");
        }, 1400);
      }, 500);
    }
  }

  customElements.define("add-to-wishlist-button", AddToWishlistButton);
}
